<template>
  <div id="notFound">
    <v-icon>mdi-alert-octagon-outline</v-icon>
    <p>
      죄송합니다.<br />
      요청하신 페이지를 찾을 수 없습니다.
    </p>
    <v-btn
      large
      depressed
      max-width="80px"
      max-height="40px"
      color="#fecd06"
      class="button-type-1 mt-10 mx-auto"
      @click.prevent="$router.push('/')"
    >
      홈으로
    </v-btn>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
#notFound {
  display: flex;
  flex-flow: column;
  justify-content: center;
  height: calc(100vh - 72px);
  text-align: center;
  .v-icon.v-icon {
    color: #ccc;
    font-size: 120px;
  }
  p {
    margin-top: 20px;
    color: #999;
    font-size: 13px;
    line-height: 1.23;
  }
}
</style>
